import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { CustomDropDown } from 'common'

// Imports custom
import { FileManagerList } from 'common'
import { TooltipInformation } from 'common'
import { Edit3, Trash2 } from 'react-feather'

export const ModalAdvanceTable = ({ useFetchInit, dataModal }) => {

    const {
        //------------- Generales
        //------------- globalStates
        globalStates,
        //------------- Helpers
        Helpers,
        //------------- Formularios
        Forms,
        //------------- FetchData
        FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    const { dataRequest: {idexpense}} = dataModal

    const { fetchAllAdvance: { advance } } = FetchData

    const { handleClickDeleteVehicleAdvance } = Actions

    const cellRendererTooltip = (params) => {
        //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
        const { usuario_creo, fecha_creo, usuario_modifico, fecha_modifico } = params.data
        return (
            <>
                <TooltipInformation
                    idregistro={idexpense}
                    usuario_creo={usuario_creo}
                    fecha_creo={fecha_creo}
                    usuario_modifico={usuario_modifico}
                    fecha_modifico={fecha_modifico}
                />
            </>

        )
    }

    const cellRendererOptions = (params) => {

        const { idadvance } = params.data

        return (
            < CustomDropDown>
                <MenuItem
                    onClick={() => handleClickDeleteVehicleAdvance(idadvance)}
                >
                    <ListItemIcon> <Trash2 color="black" /> </ListItemIcon>
                    <ListItemText primary="Eliminar" />
                </MenuItem>
            </CustomDropDown >
        )
    }

    const columnConfig = [
        {
            //FIELD PARA TOOLTIP
            headerName: "INFO",
            minWidth: 120,
            maxWidth: 120,
            cellStyle: () => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }),
            cellRenderer: cellRendererTooltip
        },
        { field: "description", headerName: "Descripcion", minWidth: 300, filter: true },
        { field: "advance", headerName: "ANTICIPO", minWidth: 120, filter: true },
        {
            headerName: "OPCIONES", minWidth: 200,
            cellRenderer: cellRendererOptions
        },
    ]


    return (
        //ESTRUCTURA PARA INCLUIR CAJA DE BUSQUEDA
        <div className='content'>
            <FileManagerList
                rowConfig={advance}
                // rowConfig={[]}
                columnConfig={columnConfig}
            />
        </div>
    )

}